import React from 'react';

import './contactCard.css';

const ContactCard = ({
  imageLink,
  headerTag,
  description,
  about,
  linkButton,
}) => {
  return (
    <div className="contact-card">
      <div className="contact-image-wrapper">
      {imageLink && (
          <img src={imageLink} className="profile-image" />
        )}
      </div>
      <div className="contact-card-details">
        <div className="contactBackground">
          <p className="label card">{description}</p>
          <h4 className="contact-card-header">{headerTag}</h4>
          <p className="contactCardtext" >{about}</p>
          <a href={linkButton} target="_blank" rel="noopener noreferrer">Stuur berichtje</a>
        </div>
      </div>
    </div>
  );
};

export default ContactCard;
